import component from './dynamicsSalesChart.vue'

export default component
